import filter from "lodash/filter";
import find from "lodash/find";
import get from "lodash/get";
import includes from "lodash/includes";
import isNil from "lodash/isNil";
import some from "lodash/some";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import getProjectId from "./getProjectId";
export const getDocuments = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].documents[${getProjectId(state)}]`), (documents) => documents);
export const getSelectedDocumentIds = createSelector((state) => getDocuments(state), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].selectedDocuments`), (documents, selectedIds) => {
    if (!documents)
        return [];
    return filter(selectedIds, id => some(documents, ["Id", id]));
});
export const getActiveDocumentId = createSelector((state) => getSelectedDocumentIds(state), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].activeDocument`), (selectedIds, activeDocument) => {
    if (activeDocument && includes(selectedIds, activeDocument))
        return activeDocument;
    return undefined;
});
export const getActiveDocument = createSelector((state) => find(getDocuments(state) || [], ["Id", getActiveDocumentId(state)]), (document) => document);
export const getActiveDocumentType = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].documentType[${getActiveDocumentId(state)}]`), (state) => getActiveDocumentId(state), (state) => getDocuments(state), (selectedType, activeDocument, documents) => {
    var _a;
    if (!activeDocument)
        return undefined;
    return !isNil(selectedType) ? selectedType : (_a = find(documents, ["Id", activeDocument])) === null || _a === void 0 ? void 0 : _a.Type;
});
